// Détecte un devis créé et déclenche un événement de suivi des leads
const DEVIS_ROUTE = '/g2r/v1/devis';
const LEAD_HEADER = 'x-g2r-lead-created';
const STORAGE_PREFIX = 'g2r_oai_lead_';

function isDevisCreateCall(url, method) {
  return 'string' === typeof url && url.includes(DEVIS_ROUTE) && 'POST' === (method || '').toUpperCase();
}

function fireLeadCreated(orderId) {
  const key = STORAGE_PREFIX + orderId;
  if (!orderId || sessionStorage.getItem(key) || 'function' !== typeof window.oaiq) {
    return;
  }
  sessionStorage.setItem(key, '1');
  window.oaiq('measure', 'lead_created', {type: 'customer_action'});
}

if (window.fetch) {
  const nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = 'string' === typeof input ? input : (input && input.url) || '';
    const method = (init && init.method) || (input && input.method) || 'GET';
    return nativeFetch.apply(this, arguments).then(function (response) {
      if (response && response.ok && isDevisCreateCall(url, method)) {
        fireLeadCreated(response.headers.get(LEAD_HEADER));
      }
      return response;
    });
  };
}

const nativeOpen = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function (method, url) {
  this.__g2rDevisCall = isDevisCreateCall(url, method);
  return nativeOpen.apply(this, arguments);
};

const nativeSend = XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.send = function () {
  if (this.__g2rDevisCall) {
    this.addEventListener('load', function () {
      if (201 === this.status) {
        fireLeadCreated(this.getResponseHeader(LEAD_HEADER));
      }
    });
  }
  return nativeSend.apply(this, arguments);
};
